module.exports = __webpack_public_path__ + "static/media/qualityCriteriaEN.2561ccc3.pdf";